import "./contact.css"
import React, { useState } from "react"
import { useInView } from "react-intersection-observer";


export default function Contact() {
    const { ref:myRef, inView:isVisible } = useInView();


const [contactData,setContactData]=useState({
    name:"",email:"",subject:'',message:""
})
const[nameError,setNameError]=useState(false)
const[emailError,setEmailError]=useState(false)

const handlechange=(event)=>{
    setContactData(prevState=>({
        ...prevState,
        [event.target.name]:event.target.value 
    }))

    if(contactData.name.length>0){
        setNameError(false)
    }
    if(contactData.email.length>0){
        setEmailError(false)
    }
}
const handleSubmit=()=>{
    console.log(contactData.name)
    if(contactData.name.length<1){
        setNameError(true)
        return
    }else if(contactData.email.length<1){
        setEmailError(true)
        return

    } else{
    const { subject, message } = contactData;
    const recipientEmail = "iannyachiro25@gmail.com";
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    window.location.href = mailtoLink;

    }
}


  
    



  return (
  
          <div className="contact" id="contact">
              <h1>CONTACT US</h1>
              <br />
              <div className={isVisible?"contactcontanner contactdelay":"contactcontanner"} ref={myRef}>

                  <div className="contanner reveal">
                      <div className="heading">
                          <div className="icon"><i className="far fa-map"></i></div>
                          <div className="info">
                              <p>Address : </p>
                              <p id="contactinfo">location,Country
                              </p>
                          </div>
                      </div>

                      <div className="heading">
                          <div className="icon"><i class="fas fa-phone-alt"></i></div>
                          <div className="info">
                              <p>Phone : </p>
                              <p id="contactinfo">+254 799589076</p>
                          </div>
                      </div>

                      <div className="heading">
                          <div className="icon"><i class="far fa-envelope"></i></div>
                          <div className="info">
                              <p>Email : </p>
                              <p id="contactinfo">yourname@example.com </p>
                          </div>
                      </div>
                  </div>

                  <div className="messageform reveal">
                      <div className="form">
                          <div className="form-form" action="" method="POST">

                              <input type="text" name="name" placeholder="NAME" required onChange={handlechange}/>
                              
                              {nameError?<p className="error">Input can not be Empty</p>:<p></p>}
                                  <input type="email" name="email" placeholder="EMAIL" required onChange={handlechange}/>
                              
                              {emailError?<p className="error">Input can not be Empty</p>:<p></p>}

                                      <input type="text" name="subject" placeholder="SUBJECT" required onChange={handlechange}/>
                                          <textarea type="message" name="message" id="inputbox" cols="30" rows="5" placeholder="MESSAGE" required onChange={handlechange}></textarea>
                                          <button type="submit" onClick={handleSubmit}>SEND MESSAGE</button>
                                          </div>

                                  </div>
                              </div>

                      </div>
                  </div>
              

              )
}